/*global Promise*/
import moment from 'moment';
import _ from 'lodash';
import Events from '../../../events/Events';
import { withTranslation } from 'react-i18next';

import React from 'react';

import { Link } from 'react-router-dom';

import ReservationConstants from '../../../constants/ReservationConstants';
import PaymentConstants from '../../../constants/PaymentConstants';
import ReservationStore from '../../../stores/ReservationStore';
import HotelStore from '../../../stores/HotelStore';
import DealStore from '../../../stores/DealStore';
import ResultsStore from '../../../stores/ResultsStore';
import ProfileStore from '../../../stores/ProfileStore';
import SearchStore from '../../../stores/SearchStore';
import PaymentStore from '../../../stores/PaymentStore';

import ReservationActions from '../../../actions/ReservationActions';
import SearchActions from '../../../actions/SearchActions';
import RouterWrapper from '../../../utils/RouterWrapper';
import Ajax from '../../../utils/Ajax';

import TravelersDetailsContainer from './components/TravelersDetailsContainer.react';
import CombtasContainer from './components/CombtasContainer.react';
import TravelBoosterContainer from './components/TravelBoosterContainer.react';

import CustomFieldsContainer from './components/CustomFieldsContainer.react';
import SpecialRequests from './components/SpecialRequests';
import TermsOfSupplier from './components/TermsOfSupplier';
import BillingSection from './components/BillingSection.react';

import MaterialDesignDialog from '../../general/MaterialDesignDialog.react';

import PaymentComponent from './PaymentComponent.react';
import ValidationDialog from './ValidationDialog.react';

import TitleManager from '../../../utils/TitleManager';

import Validator from 'arbitrip-common/client/utils/Validator';
import PriceBreakdown from 'arbitrip-common/client/utils/PriceBreakdown';
import { Dates as DateUtils } from 'arbitrip-common/client/utils';

import Analytics from 'arbitrip-common/client/analytics';
import { ERROR_TYPE, PAGE_PROCESS, FUNNEL_STEP } from 'arbitrip-common/client/analytics/constants/interactions';
import Points from 'arbitrip-common/general/utils/Points';
import { isElalCompany } from '@/utils/isCompany';
import {
    AccountPaymentAvailabilityFetcher,
    companyOffersInvoiceIdentityChoice,
    getAccountPaymentUnavailableMonthLabel,
    isCreditLineOffForCompany,
    isInvoiceIdentityUnresolved,
} from '@/utils/AccountPaymentAvailability';

import EventsConstants from '../../../events/constants/ReservationPaymentPage';

import { Select, MenuItem, FormControl, Checkbox, Button, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { STATUS } from 'arbitrip-common/client/constants/ReservationConstants';
import ClientPriceService from 'arbitrip-common/client/utils/ClientPriceService';
import { withRouter } from '../../../utils/withRouter';
import DocumentTitle from '../../general/DocumentTitle.react';
import Currencies from '../../../utils/Currencies';
import ProfileConstants from '../../../constants/ProfileConstants';
import PointsStore from '../../../stores/PointsStore';
import PointsActions from '../../../actions/PointsActions';
import { ReactComponent as PointsIcon } from '../../../img/search_page/loyalty/present-plain.svg';
import HotelDetailsContainer from './components/HotelDetailsContainer.react';
import PriceSummary from './components/PriceSummary.react';
import CancellationTermsContainer from './components/CancellationTermsContainer.react';
import BnplTopBanner from './components/BnplTopBanner.react';
import ContentLoader from 'react-content-loader';
import PointsConstants from '../../../constants/PointsConstants';
import * as Sentry from '@sentry/react';
import AutoFiller from './helpers/AutoFiller';
import { Config } from 'arbitrip-common/client/utils';
import ConfirmationPage from '../confirmation/ConfirmationPage';
import ExpediaDealDetailsContainer from './components/ExpediaDealDetailsContainer.react';
import { ReactComponent as AttentionIcon } from '../../../img/icons/attention.svg';
import HotelActions from '../../../actions/HotelActions';
import channel from '@/utils/BroadcastChannel';
import { getTasIdFromSessionStorage, removeTasIdFromSessionStorage } from '@/utils/TasId';
import { isPendingStatus, RESERVATION_DIALOG_VARIANT, isReservationIdField } from './helpers';
import ReservationDialog from './components/ReservationDialog.react';
import TermsChangedDialog from './components/TermsChangedDialog.react';
import RecheckAlternative, { RECHECK_TYPE } from 'arbitrip-common/client/utils/RecheckAlternative';
import PaymentActions from '../../../actions/PaymentActions';
import ExpiredResultsComponent from '../../general/expired-results/ExpiredResultsComponent.react';
import ExpiredResultsConstants from '../../general/expired-results/constants';
import DoubleBookingDialog from '../../general/DoubleBookingDialog';

const { SCROLL_TO_TRAVELER, SAVE_TRAVELER_CARD } = EventsConstants;
const { EXPIRED_TYPES } = ExpiredResultsConstants;

const ERROR_TEXT_BOOKING_FAILED = 'booking_failed';
const ERROR_TEXT_ROOM_NOT_AVAILABLE = 'room_not_available';

// Same "failed" branch reservationStateDialogs() renders, plus the inline partner error that replaces the modal.
function isBookingErrorDisplayed(state) {
    const { modalIsOpen, isShowReservationError, reservationData, out_of_policy_state, out_of_policy_request_status } =
        state;
    const isOutOfPolicy =
        out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK &&
        out_of_policy_request_status === ReservationConstants.STATUS.SUCCESS;
    const isError =
        !isPendingStatus(reservationData.status) &&
        reservationData.status !== ReservationConstants.STATUS.BOOKED &&
        !isOutOfPolicy;

    return (modalIsOpen && isError) || (isShowReservationError && !!reservationData.bookingError);
}

function isNonEmptyArray(arr) {
    return Array.isArray(arr) && !!arr.length;
}

function getReservationPageState() {
    const reservation_data = ReservationStore.getReservationData();

    if (SearchStore.isPrivateTravel()) {
        // Ignores custom fields when it's private travel
        reservation_data.company_custom_fields = null;
    }

    const points = PointsStore.getPoints();

    return {
        reservationData: reservation_data,
        paymentData: PaymentStore.getPaymentData(),
        hotel: HotelStore.getHotelData(),
        deal: DealStore.getDealData(),
        travel_policy: ResultsStore.getTravelPolicy(),
        profile: ProfileStore.getProfile(),
        points_status: PointsStore.getStatus(),
        points_balance: _.get(points, 'balance', 0),
        points_upcoming_value: _.get(points, 'upcoming_points_value', 0),
        points_upcoming_timestamp: _.get(points, 'upcoming_points_timestamp', null),
        search_token: SearchStore.getToken(),
        hotel_search_token: SearchStore.getHotelToken(),
        search_extra: SearchStore.getExtraData(),
        search_terms: SearchStore.getSearchTerms(),
        contract_client_name: SearchStore.getContractClientName(),
        contract_client_company_id: SearchStore.getContractClientCompanyId(),
        showConfirmationPage: false,
        modalIsOpen: false,
        isShowReservationError: false,
        creditLineModalIsOpen: false,
        validationModalIsOpen: false,
        failedReservationInitializationModalIsOpen: false,
        textBoxError: false,
        // BUG 51 follow-up — no `invoice_option` mirror of the selected payment entity lives in state
        // any more. `reservationData.invoice_id` is the ONE spelling: it is what the store holds, what
        // `Ajax.requestOutOfPolicyRoom`/`advanceReservation` put on the wire, and what the availability
        // read asks about. A second copy could only ever disagree with it. See getSelectedInvoiceId.
        out_of_policy_state: _.get(reservation_data, 'deal.out_of_policy_state', null),
        out_of_policy_request_status: ReservationStore.getOutOfPolicyRequestStatus(),
        create_traveler_statuses: ReservationStore.getCreateTravelerStatuses(),
        private_travel: SearchStore.isPrivateTravel(),
        derived_from: SearchStore.getDerivedFrom(),
        post_pay: DealStore.isPostPay(),
        selected_company_custom_field: -1,
        selected_company_custom_field_secondary: -1,
        company_custom_text_fields: {},

        company_custom_input_selectable: null,
        company_custom_input_text: null,
        company_custom_input_number: null,
        company_custom_input_datetime: null,
        selected_custom_fields_path: '',
        selected_custom_fields_paths: [],
        combtas_id: getTasIdFromSessionStorage() || SearchStore.getCombtasId() || '',
        tas_id_ref: getTasIdFromSessionStorage(),
        travel_booster_docket_number: SearchStore.getTravelBoosterDocketNumber() || '',
        isShowExpiredError: false,
        doubleBookingModalIsOpen: false,
        isDoubleBooking: ReservationStore.isDoubleBooking(),
        doubleBookingStatus: ReservationStore.isDoubleBookingStatus(),
        doubleBookingExistingReservations: ReservationStore.getDoubleBookingExistingReservations(),

        points,
        bnpl_method: null,
    };
}

function getContentLoader(width, height, radius = 0) {
    return (
        <ContentLoader
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            className="maximum-points-earned-content-loader"
        >
            <rect x="0" y="0" rx={radius} yx={radius} width={width} height={height} />
        </ContentLoader>
    );
}

class ReservationPaymentPage extends React.Component {
    constructor(props) {
        super(props);

        let initState = getReservationPageState();

        initState.quotedReservationModalIsOpen = false;
        initState.send_email = initState.profile.send_traveler_emails_under_guest_email;
        initState.show_send_voucher_separately_from_confirmation_mail =
            initState.profile.show_send_voucher_separately_from_confirmation_mail;

        if (initState.profile.agent) {
            initState.send_voucher_separately_from_confirmation_mail =
                localStorage.getItem('sendVoucherSeparatelyFromConfirmationMail') === 'true';
        }

        initState.combtas_integration_enabled = initState.profile.company.settings.combtas_integration_enabled;
        initState.combtas_integration_mandatory = initState.profile.company.settings.combtas_integration_mandatory;

        initState.travel_booster_integration_enabled = initState.profile.settings.travel_booster_integration_enabled;
        initState.travel_booster_integration_mandatory =
            initState.profile.company.settings.travel_booster_integration_mandatory;

        initState.isSpecialRequestsChecked = false;
        initState.billing_validation_enabled = false;

        // OB-35: null until the live per-identity answer lands, which leaves the request button
        // enabled — the FAIL-OPEN direction. See AccountPaymentAvailabilityFetcher.
        initState.account_payment_availability = null;

        // BUG 55 — is a credit-line availability read IN FLIGHT for the entity currently selected?
        // Distinct from `account_payment_availability === null`, which conflates "not asked", "asking"
        // and "asked and failed". Only the middle one may withhold the button, and only it can name a
        // "checking…" sentence. Owned by the fetcher (onPending); this is its mirror in state.
        initState.account_payment_availability_pending = false;

        // initState.show_package_disclaimer = initState.profile.package_disclaimer_enabled && initState.deal.package;
        // initState.package_disclaimer_checked = true;
        initState.loading = true;
        initState.isDoubleBookingModalIsOpen = false;

        this.state = initState;

        ////////////////////////////////////////////////////////////////////////////////
        // bindings //
        //////////////

        this._onChange = this._onChange.bind(this);
        this.addQuote = this.addQuote.bind(this);
        this.getAddQuoteDisabledStatus = this.getAddQuoteDisabledStatus.bind(this);
        this.getPaymentOptionsDisabledStatus = this.getPaymentOptionsDisabledStatus.bind(this);
        this.getTravelersContactPromise = this.getTravelersContactPromise.bind(this);
        this.requestThisRoom = this.requestThisRoom.bind(this);
        this.getAdvanceReservationFields = this.getAdvanceReservationFields.bind(this);
        this.updateOutOfPolicyRequestReason = this.updateOutOfPolicyRequestReason.bind(this);
        this.onArbiManagementTripAssociation = this.onArbiManagementTripAssociation.bind(this);
        this.showPaymentComponentOnQuoteFlow = this.showPaymentComponentOnQuoteFlow.bind(this);
        this.getOutOfPolicyRequestButton = this.getOutOfPolicyRequestButton.bind(this);
        this._scheduleAccountPaymentAvailabilityFetch = this._scheduleAccountPaymentAvailabilityFetch.bind(this);
        this.getSelectedInvoiceId = this.getSelectedInvoiceId.bind(this);
        this.hasUnresolvedInvoiceIdentity = this.hasUnresolvedInvoiceIdentity.bind(this);
        this._onAccountPaymentAvailability = this._onAccountPaymentAvailability.bind(this);
        this._onAccountPaymentAvailabilityPending = this._onAccountPaymentAvailabilityPending.bind(this);
        this.isAccountPaymentAvailabilityPending = this.isAccountPaymentAvailabilityPending.bind(this);
        this.getMaximumPointsEarnedRender = this.getMaximumPointsEarnedRender.bind(this);
        this.isLoyaltyEnabled = this.isLoyaltyEnabled.bind(this);
        this.clearSpecialRequests = this.clearSpecialRequests.bind(this);

        // booleans

        this.didGetPaymentData = this.didGetPaymentData.bind(this);
        this.didMakeReservation = this.didMakeReservation.bind(this);

        this.isReservationPostInitialStatus = this.isReservationPostInitialStatus.bind(this);
        this.isPayAtHotel = this.isPayAtHotel.bind(this);
        this.isMakingOutOfPolicyRequest = this.isMakingOutOfPolicyRequest.bind(this);
        this.isQuoting = this.isQuoting.bind(this);
        this.isMakingReservation = this.isMakingReservation.bind(this);
        this.isInitializingPayment = this.isInitializingPayment.bind(this);
        this.isBusy = this.isBusy.bind(this);
        this.isCombtasEnabled = this.isCombtasEnabled.bind(this);
        this.isTravelBoosterEnabled = this.isTravelBoosterEnabled.bind(this);
        this.isAgencyClientPriceEnabled = this.isAgencyClientPriceEnabled.bind(this);

        this.shouldLockForm = this.shouldLockForm.bind(this);
        this.shouldDisableAddAsQuoteAndProceedButtons = this.shouldDisableAddAsQuoteAndProceedButtons.bind(this);
        this.shouldShowQuote = this.shouldShowQuote.bind(this);

        // modals

        this.openModal = this.openModal.bind(this);
        this.openValidationModal = this.openValidationModal.bind(this);
        this.openQuotedReservationModal = this.openQuotedReservationModal.bind(this);
        this.openFailedReservationInitializationModal = this.openFailedReservationInitializationModal.bind(this);

        this.closeModal = this.closeModal.bind(this);
        this.closeCreditLineCheckUnavailableModal = this.closeCreditLineCheckUnavailableModal.bind(this);
        this.closeValidationModal = this.closeValidationModal.bind(this);
        this.closeQuotedReservationModal = this.closeQuotedReservationModal.bind(this);
        this.closeFailedReservationInitializationModal = this.closeFailedReservationInitializationModal.bind(this);

        this.afterOpenModal = this.afterOpenModal.bind(this);

        // validations

        this.validateForm = this.validateForm.bind(this);
        this.validateTravelers = this.validateTravelers.bind(this);
        this.validateTravelersContacts = this.validateTravelersContacts.bind(this);
        this.forceTravelBoosterDocketNumberValidation = this.forceTravelBoosterDocketNumberValidation.bind(this);

        // change handlers

        this.onTripIdChange = this.onTripIdChange.bind(this);
        this.onCombtasIdChange = this.onCombtasIdChange.bind(this);
        this.onTravelBoosterDocketNumberChange = this.onTravelBoosterDocketNumberChange.bind(this);
        this.onShouldCreateNewDocketChanged = this.onShouldCreateNewDocketChanged.bind(this);
        this.onAgencyClientPriceChange = this.onAgencyClientPriceChange.bind(this);
        this.onPriceComparableChange = this.onPriceComparableChange.bind(this);
        this.handleBnplMethodChange = this.handleBnplMethodChange.bind(this);

        this.handleSendEmailCheckboxChange = this.handleSendEmailCheckboxChange.bind(this);
        this.handleSendVoucherSeparatelyCheckboxChange = this.handleSendVoucherSeparatelyCheckboxChange.bind(this);
        this.handleCompanyCustomInputNumberChange = this.handleCompanyCustomInputNumberChange.bind(this);
        this.handleCompanyCustomInputTextChange = this.handleCompanyCustomInputTextChange.bind(this);
        this.handleCustomTextFieldChange = this.handleCustomTextFieldChange.bind(this);
        this.handleInvoiceChange = this.handleInvoiceChange.bind(this);
        // this.handlePackageDisclaimerCheckboxChange = this.handlePackageDisclaimerCheckboxChange.bind(this);
        this.handleSelectedCustomFieldChange = this.handleSelectedCustomFieldChange.bind(this);
        this.handleSelectedCustomFieldPathChange = this.handleSelectedCustomFieldPathChange.bind(this);
        this.handleSelectedSecondaryCustomFieldChange = this.handleSelectedSecondaryCustomFieldChange.bind(this);
        this.handleSpecialRequestCheckboxChange = this.handleSpecialRequestCheckboxChange.bind(this);
        // renders

        this.getClientTripIdRender = this.getClientTripIdRender.bind(this);
        this.getCombtasRender = this.getCombtasRender.bind(this);
        // this.getLoyaltyBoxRender = this.getLoyaltyBoxRender.bind(this);
        this.getTravelBoosterRender = this.getTravelBoosterRender.bind(this);
        // this.getAgencyClientPriceRender = this.getAgencyClientPriceRender.bind(this);
        this.getGoToPaymentContainerRender = this.getGoToPaymentContainerRender.bind(this);
        this.getPaymentComponentRender = this.getPaymentComponentRender.bind(this);
        this.getReservationErrorRender = this.getReservationErrorRender.bind(this);
        this.getPriceChangedModal = this.getPriceChangedModal.bind(this);
        this.getSpinnerRender = this.getSpinnerRender.bind(this);
        this.getMakeReservationRender = this.getMakeReservationRender.bind(this);
        this.onCouponValidated = this.onCouponValidated.bind(this);
        this.getManagementTripIdRender = this.getManagementTripIdRender.bind(this);
        this.getIssueInvoiceRender = this.getIssueInvoiceRender.bind(this);
        this.getOutOfPolicyRequestRender = this.getOutOfPolicyRequestRender.bind(this);
        // this.getPackageDislaimerRender = this.getPackageDislaimerRender.bind(this);

        // points
        this.handleApproveRedeemPoints = this.handleApproveRedeemPoints.bind(this);
        this.handleCloseRedeemPoints = this.handleCloseRedeemPoints.bind(this);
        this.handleClickRedeemPoints = this.handleClickRedeemPoints.bind(this);

        this.reservationStateDialogs = this.reservationStateDialogs.bind(this);
        this.handleDoubleBookingDialogResponse = this.handleDoubleBookingDialogResponse.bind(this);
        this.checkDoubleBooking = this.checkDoubleBooking.bind(this);

        ////////////////////////////////////////////////////////////////////////////////

        this._account_availability_fetcher = new AccountPaymentAvailabilityFetcher(
            this._onAccountPaymentAvailability,
            {
                // BUG 55 — the button must not be live while this read is outstanding. Without it the
                // customer could submit inside the in-flight window and have the SERVER refuse
                // (NOT_ENOUGH_CREDIT_LINE_BALANCE) a request the page was still deciding about.
                onPending: this._onAccountPaymentAvailabilityPending,
            },
        );

        this.displayName = 'ReservationPaymentPage';
    }
    onCouponValidated(validation) {
        this.setState({ coupon_validation: validation });
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const { navigate } = this.props;
        const {
            deal,
            reservationData,
            hotel,
            search_token,
            search_terms,
            travel_policy,
            search_extra,
            profile,
            hotel_search_token,
        } = this.state;

        if (!deal || !deal.chooseprod) {
            return RouterWrapper.goToHotelPage(navigate, hotel, search_token, search_terms);
        } else if (!reservationData || Object.keys(deal).length === 0 || Object.keys(hotel).length === 0) {
            return RouterWrapper.goToSearchPage(navigate);
        }

        ReservationStore.addChangeListener(this._onChange);
        PaymentStore.addChangeListener(this._onChange);
        ProfileStore.addChangeListener(this._onChange);
        PointsStore.addChangeListener(this._onChange);

        ReservationActions.clearReservation();

        this.setState({ loading: true });
        ReservationActions.openNewReservation(
            deal,
            hotel,
            search_token,
            travel_policy,
            search_extra.group_id,
            profile,
            hotel_search_token,
        );

        PointsActions.getPointsIfApplicable(profile);

        Analytics.actions.views.reservationPage(profile, hotel, search_terms, deal);

        if (Config.force_auto_fill || (Config.dev_mode && Config.auto_fill)) {
            setTimeout(() => {
                AutoFiller.autoFill({ profile, search_terms });
            }, 1);
        }

        this._is_mounted = true;

        this._maybeFireRateCheckShown(null);
        this._scheduleAccountPaymentAvailabilityFetch();
    }

    _maybeFireRateCheckShown(prevState) {
        const prevPcd = prevState?.reservationData?.deal?.priceChangedData;
        const currPcd = this.state.reservationData?.deal?.priceChangedData;
        const wasShowing = prevPcd && !prevPcd.confirmedChange;
        const isShowing = currPcd && !currPcd.confirmedChange;
        if (wasShowing || !isShowing) return;

        this._rateCheckPopupCount = Analytics.actions.responses.roomRateCheckPopupShown({
            popup_type: 'changes_detected',
            recheck_type: RECHECK_TYPE.UPFRONT,
            price_changed: true,
            old_price: currPcd.oldPrice,
            new_price: currPcd.newPrice,
            deadline_changed: false,
            deal: this.state.deal,
            search_id: this.state.search_token,
            user: this.state.profile,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            // reservationData,
            // selected_company_custom_field,
            // selected_company_custom_field_secondary,
            // company_custom_text_fields,
            out_of_policy_request_status,
        } = this.state;

        // const client_custom_fields = getClientCustomFields(
        //     reservationData.company_custom_fields,
        //     selected_company_custom_field,
        //     selected_company_custom_field_secondary,
        //     company_custom_text_fields
        // );

        // console.log("client_custom_fields:", client_custom_fields);

        if (
            prevState.out_of_policy_request_status === ReservationConstants.STATUS.BUSY &&
            (out_of_policy_request_status === ReservationConstants.STATUS.SUCCESS ||
                out_of_policy_request_status === ReservationConstants.STATUS.FAILED)
        ) {
            this.openModal();
        }

        const status = _.get(this.state, 'reservationData.status');
        if (this.state.loading && status === ReservationConstants.STATUS.INITIALIZED) {
            this.setState({ loading: false });
            // Pre-fill billing email from profile when ELAL
            if (isElalCompany() && !_.get(this.state, 'reservationData.billing_email') && _.get(this.state, 'profile.email')) {
                ReservationActions.updateBillingEmail(this.state.profile.email);
            }
        }

        if (!this.state.isShowExpiredError && status === ReservationConstants.STATUS.EXPIRED) {
            this.setState({ isShowExpiredError: true });
        }

        //double booking
        const busy = ReservationConstants.STATUS.BUSY;
        if (prevState.doubleBookingStatus === busy && this.state.doubleBookingStatus !== busy) {
            this.setState({ checkingDoubleBooking: false });
            if (this.state.isDoubleBooking) {
                this.setState({ isDoubleBookingModalIsOpen: true });
                Analytics.actions.views.openDoubleBookingDialog(this.props.profile, this.state.reservationData.id);
            } else if (this.state.out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK) {
                this.requestOutOfPolicyRoom();
            }
        }

        this._maybeFireRateCheckShown(prevState);
        this._maybeFireErrorDisplayed(prevState);

        // The invoice identity is mutated ON the reservation object held by ReservationStore
        // (UPDATE_INVOICE_OPTION), so prevState.reservationData and this.state.reservationData can be
        // the very same reference — comparing prevState here would miss the entity switch entirely.
        // The fetcher compares the identity key it last asked about instead.
        this._scheduleAccountPaymentAvailabilityFetch();
    }

    _maybeFireErrorDisplayed(prevState) {
        if (isBookingErrorDisplayed(this.state) && !isBookingErrorDisplayed(prevState)) {
            this._fireSystemErrorDisplayed(ERROR_TEXT_BOOKING_FAILED);
        }
        if (
            this.state.failedReservationInitializationModalIsOpen &&
            !prevState.failedReservationInitializationModalIsOpen
        ) {
            this._fireSystemErrorDisplayed(ERROR_TEXT_ROOM_NOT_AVAILABLE);
        }
    }

    _fireSystemErrorDisplayed(error_text) {
        Analytics.actions.interactions.errorDisplayed(this.state.profile, {
            error_type: ERROR_TYPE.SYSTEM,
            error_text,
            process: PAGE_PROCESS.HOTEL_RESERVATION,
            step: FUNNEL_STEP.PAYMENT,
        });
    }

    // OB-35 — the out-of-policy request flow renders NO payment component (see
    // getPaymentComponentRender), so it must ask the availability question itself. Only asked in the
    // BLOCK state, which is the only state that renders the request button.
    _scheduleAccountPaymentAvailabilityFetch() {
        if (this.state.out_of_policy_state !== ReservationConstants.OUT_OF_POLICY_STATE.BLOCK) {
            return;
        }

        this._account_availability_fetcher.schedule(
            _.get(this.state, 'reservationData.id'),
            this.getSelectedInvoiceId(),
            {
                identity_unresolved: this.hasUnresolvedInvoiceIdentity(),
                credit_line_off: isCreditLineOffForCompany(_.get(this.state, 'profile.company')),
            },
        );
    }

    // THE ONE SPELLING of "which payment entity is this booking billed to".
    //
    // The selector renders it, validateForm requires it, the availability read asks about it, and
    // `Ajax.requestOutOfPolicyRoom` / `Ajax.advanceReservation` put this exact field on the wire
    // (`invoice_id: reservation.invoice_id`). It is stored in ONE place — `ReservationStore`'s
    // `_reservation.invoice_id`, written by UPDATE_INVOICE_OPTION — and every consumer must read it
    // from here. A second state copy of the same fact is what the BUG 51 note warns against: two
    // spellings can disagree about whether a selection is still outstanding, and the one that is
    // wrong either suppresses an answer we could have had or claims one we could not.
    //
    // Read live off `reservationData` on purpose: UPDATE_INVOICE_OPTION MUTATES that object in place,
    // so a value snapshotted into component state can lag it by a render. Never compare against
    // prevState here for the same reason — the fetcher compares the identity key it last asked about.
    getSelectedInvoiceId() {
        return _.get(this.state, 'reservationData.invoice_id');
    }

    // BUG 51 — the payment entity this booking will be invoiced to is not chosen yet, on a company
    // that must choose one (validateForm refuses to submit without it). Caps are per entity, so there
    // is nothing to ask about and nothing to claim: see isInvoiceIdentityUnresolved.
    hasUnresolvedInvoiceIdentity() {
        return isInvoiceIdentityUnresolved({
            company: _.get(this.state, 'profile.company'),
            private_travel: this.state.private_travel,
            invoice_id: this.getSelectedInvoiceId(),
        });
    }

    // A null answer arrives when the selected payment entity CHANGES: the previous entity's answer
    // does not describe the new one, so for the debounce + round-trip window it would name the wrong
    // month and keep the request button disabled even when the new entity has room. Drop back to
    // "no opinion yet" — the FAIL-OPEN direction.
    _onAccountPaymentAvailability(availability) {
        if (availability === null && this.state.account_payment_availability === null) {
            return;
        }

        this.setState({ account_payment_availability: availability });
    }

    // BUG 55 — edge-triggered by the fetcher: `true` when a read is scheduled for a newly selected
    // entity (debounce included), `false` when that read answers, WHATEVER it answers. The fetcher
    // guarantees the pair, so this can never strand.
    _onAccountPaymentAvailabilityPending(pending) {
        this.setState({ account_payment_availability_pending: pending });
    }

    // THE RACE THIS CLOSES: the read is issued when the entity is chosen, the verdict lands a round
    // trip later, and in between the button used to be live. A click in that window reached `/pay`,
    // came back NOT_ENOUGH_CREDIT_LINE_BALANCE, and the customer was refused by the server for a cap
    // the page was in the middle of checking.
    //
    // PENDING FAILS CLOSED; a FAILED READ FAILS OPEN. They are different situations and deliberately
    // resolve differently. Pending is a verdict we are about to have — waiting costs one round trip
    // and admitting on it is exactly what this gate exists to prevent. A failed read is a verdict we
    // are NOT going to have, and withholding the control on it (OB-6) would turn an endpoint outage
    // into a customer-visible refusal; `/pay` stays authoritative and refuses on its own. Neither can
    // strand the button: pending is cleared on both arms of the read.
    isAccountPaymentAvailabilityPending() {
        return this.state.account_payment_availability_pending === true;
    }

    // THE LIVE ANSWER ALONE, and OB-45 is why the `company_policy_available` snapshot is no longer
    // composed in here.
    //
    // That snapshot is the BOOKING rule: it is the month's `state`, which turns `block` at the block
    // THRESHOLD and is amount-independent. Under the request rule a request must still be sendable
    // between the threshold and the cap, so and-ing the snapshot in would disable the button for
    // exactly the requests this fix exists to admit. Nothing is lost: the live read is strictly the
    // more precise question — same reservation, same invoice entity, same amount, same server-side
    // predicate as the gate — and it withholds on a manual block and a non-member identity too.
    //
    // FAIL OPEN is unchanged: `null` is "no opinion yet" (pending, or a read that failed), and it
    // leaves the request sendable. The server gate stays the authority.
    isAccountPaymentOfferedForRequest() {
        const availability = this.state.account_payment_availability;

        return availability ? availability.available : true;
    }

    // ONE neutral string for every refusal cause — the endpoint's `reason` is for logs only and must
    // never reach the screen. The only thing that varies the copy is whether we know which month is
    // short.
    getOutOfPolicyRequestUnavailableReason() {
        const { t } = this.props;
        const month = getAccountPaymentUnavailableMonthLabel(this.state.account_payment_availability);

        if (!month) {
            return t('RequestThisRoomUnavailableNoMonth');
        }

        return t('RequestThisRoomUnavailableForMonth', { month });
    }

    componentWillUnmount() {
        this._is_mounted = false;
        this._account_availability_fetcher.dispose();

        setTimeout(() => {
            ReservationActions.clearReservation();
        }, 1);

        PaymentStore.removeChangeListener(this._onChange);
        ReservationStore.removeChangeListener(this._onChange);
        ProfileStore.removeChangeListener(this._onChange);
        PointsStore.removeAllListeners(this._onChange);

        // this.setState({
        //     modalIsOpen: false,
        //     validationModalIsOpen: false,
        //     failedReservationInitializationModalIsOpen: false
        // });
    }

    closeValidationModal() {
        this.setState({ validationModalIsOpen: false });
    }

    requestThisRoom() {
        const { profile, reservationData } = this.state;

        if (!reservationData.out_of_policy_booking_reason?.trim()) {
            this.setState({ textBoxError: true });
            return;
        }

        this.setState({ textBoxError: false });

        if (this.validateForm()) {
            const enableDoubleBookingCheck = _.get(profile, 'company.settings.enable_double_booking_check', true);
            if (enableDoubleBookingCheck) {
                this.checkDoubleBooking();
            } else {
                this.advanceRefundableReservationOrOpenNonRefundableModal();
            }
        }
    }

    requestOutOfPolicyRoom() {
        const {
            profile,
            reservationData,
            selected_company_custom_field,
            selected_company_custom_field_secondary,
            company_custom_text_fields,
            trip_id,
            search_token,
            send_email,
            combtas_id,
            travel_booster_docket_number,
            travel_booster_should_create_a_new_docket,
            price_comparable,
            deal,
            search_terms,
            hotel_search_token,
        } = this.state;

        const client_custom_fields = getClientCustomFields(
            reservationData.company_custom_fields,
            selected_company_custom_field,
            selected_company_custom_field_secondary,
            company_custom_text_fields,
        );

        ReservationActions.requestOutOfPolicyRoom({
            reservation: reservationData,
            trip_id,
            search_token,
            send_email_confirmation: send_email,
            combtas_id,
            travel_booster_docket_number,
            travel_booster_should_create_a_new_docket,
            price_comparable,
            currency: deal.currency,
            client_custom_fields,
            search_terms,
            hotel_search_token,
        });

        try {
            Analytics.actions.interactions.requestOutOfPolicyRoom(
                profile.company,
                profile,
                reservationData.out_of_policy_booking_reason,
            );
        } catch (e) {
            console.error(e);
            Sentry.captureException(e);
        }
    }

    openValidationModal() {
        this.setState({ validationModalIsOpen: true, billing_validation_enabled: true });
    }

    validateTravelers() {
        const travelers = _.get(this.state, 'reservationData.travelers', []);
        return travelers.every((traveler) => traveler.isValid());
    }

    // OB-53 — every rule that refuses the form now NAMES itself. The request button is disabled by a
    // disjunction (getOutOfPolicyRequestButton) and, until this existed, only the credit-line term had
    // copy: every other refusal produced a dead button and a `console.warn` the customer never sees.
    //
    // Returns `null` when the form is submittable, otherwise `{ log, key, params }` — `log` is the
    // developer wording the warn has always carried, `key`/`params` are what the screen renders. Keep
    // the two in step: a rule added here without a `key` is a silent dead button again.
    getFormInvalidation() {
        const {
            private_travel,
            profile,
            reservationData,
            combtas_id,
            combtas_integration_mandatory,
            travel_booster_docket_number,
            travel_booster_integration_mandatory,
            travel_booster_should_create_a_new_docket,
            selected_company_custom_field: selected_company_custom_field_index,
            selected_company_custom_field_secondary,
            company_custom_text_fields,
        } = this.state;

        // ONE spelling of "this company must choose an invoice entity", and ONE spelling of which one
        // was chosen (getSelectedInvoiceId) — shared with the selector that renders it and with the
        // availability read that must not ask about a cap before it is chosen (BUG 51). Three copies
        // of it could disagree about whether a selection is still outstanding.
        if (companyOffersInvoiceIdentityChoice(profile.company, private_travel) && !this.getSelectedInvoiceId()) {
            return { log: 'no invoice option', key: 'RequestThisRoomDisabledNoInvoiceCompany' };
        }

        // BUG 55 — the credit-line read for the SELECTED entity has not answered yet. Reported through
        // this one function on purpose: it is what both the disabled boolean and the on-screen sentence
        // derive from, and `validateForm` reads it too — so a click that beats the re-render is still
        // refused at the submit path rather than reaching `/pay`. A SECOND disabled path would be a
        // second thing to keep in step with the sentence.
        //
        // NOT the cap-exceeded copy. That claim stays strictly gated on a live `available: false`
        // (getOutOfPolicyRequestDisabledReason → isAccountPaymentOfferedForRequest); saying the credit
        // line is short while we are still asking asserts something about the customer's account that
        // nothing has established.
        if (this.isAccountPaymentAvailabilityPending()) {
            return {
                log: 'credit line availability read in flight',
                key: 'RequestThisRoomDisabledCheckingAvailability',
            };
        }

        if (this.isCombtasEnabled()) {
            // combtas is mandatory but no value was filled
            if (combtas_integration_mandatory && !combtas_id) {
                return { log: 'no combtas id', key: 'RequestThisRoomDisabledNoCombtasId' };
            }

            // combtas was filled but value is invalid
            if (combtas_id && !Validator.validateCombtasId(combtas_id)) {
                return { log: 'invalid combtas id', key: 'RequestThisRoomDisabledInvalidCombtasId' };
            }
        }

        // if (profile.loyalty.enabled) {
        //     if (this.state.points_status !== ProfileConstants.STATUS.SUCCESS) {
        //         return false;
        //     }
        // }

        if (this.isTravelBoosterEnabled()) {
            if (
                travel_booster_integration_mandatory &&
                !travel_booster_should_create_a_new_docket &&
                !travel_booster_docket_number
            ) {
                return {
                    log: 'missing travel booster docket number (or create a new docket option)',
                    key: 'RequestThisRoomDisabledNoTravelBoosterDocket',
                };
            }

            if (
                travel_booster_docket_number &&
                !Validator.validateTravelBoosterDocketNumber(travel_booster_docket_number, profile)
            ) {
                return {
                    log: 'invalid travel booster docket number',
                    key: 'RequestThisRoomDisabledInvalidTravelBoosterDocket',
                };
            }
        }

        const company_fields = reservationData.company_custom_fields;

        // validate custom combobox fields
        if (isNonEmptyArray(company_fields)) {
            const first_combobox_custom_field = company_fields.find((custom_field) =>
                isNonEmptyArray(_.get(custom_field, 'list')),
            );
            if (first_combobox_custom_field) {
                if (Number(selected_company_custom_field_index) === -1) {
                    // index might be string - that's why '==' and not '==='
                    return { log: 'no custom field', key: 'RequestThisRoomDisabledNoCustomField' };
                }

                if (
                    first_combobox_custom_field.list[selected_company_custom_field_index] &&
                    first_combobox_custom_field.list[selected_company_custom_field_index].list &&
                    Number(selected_company_custom_field_secondary) === -1
                ) {
                    // index might be string - that's why '==' and not '==='
                    return {
                        log: 'no secondary custom field',
                        key: 'RequestThisRoomDisabledNoSecondaryCustomField',
                    };
                }
            }
        }

        // validate billing email when ELAL
        if (isElalCompany()) {
            const billing_email = _.get(reservationData, 'billing_email', '');
            if (!billing_email || !Validator.validateEmailAddress(billing_email)) {
                return {
                    log: 'billing email required and must be valid',
                    key: 'RequestThisRoomDisabledInvalidBillingEmail',
                };
            }
        }

        // validate custom text fields
        if (_.isArray(company_fields) && !_.isEmpty(company_fields)) {
            // iterate through custom fields
            const missing_text_field = _.find(company_fields, (field) => {
                if (field.field_required && field.field_type === 'text') {
                    // retrieve the corresponding field from the form
                    const textFieldValue = _.get(company_custom_text_fields, [field._id, 'value'], '');

                    return _.isEmpty(_.trim(textFieldValue));
                }

                return false;
            });

            if (missing_text_field) {
                // A field with no label cannot be named on screen — say "the required fields above"
                // rather than render an empty pair of quotes.
                return {
                    log: 'required custom text field missing or empty: ' + missing_text_field.label,
                    ...(missing_text_field.label
                        ? {
                              key: 'RequestThisRoomDisabledMissingCustomTextField',
                              params: { field: missing_text_field.label },
                          }
                        : { key: 'RequestThisRoomDisabledMissingRequiredField' }),
                };
            }
        }

        return null;
    }

    validateForm() {
        const invalidation = this.getFormInvalidation();

        if (invalidation) {
            console.warn('validateForm :::', invalidation.log);
        }

        return !invalidation;
    }

    getAdvanceReservationFields() {
        const {
            reservationData,
            selected_company_custom_field,
            selected_company_custom_field_secondary,
            company_custom_text_fields,
            trip_id,
            search_token,
            send_voucher_separately_from_confirmation_mail,
            send_email,
            combtas_id,
            travel_booster_docket_number,
            travel_booster_should_create_a_new_docket,
            price_comparable,
            deal,
            search_terms,
            hotel_search_token,
            points = {},
        } = this.state;

        const client_custom_fields = getClientCustomFields(
            reservationData.company_custom_fields,
            selected_company_custom_field,
            selected_company_custom_field_secondary,
            company_custom_text_fields,
        );

        return {
            reservationData,
            trip_id,
            search_token,
            send_voucher_separately_from_confirmation_mail,
            send_email,
            combtas_id,
            travel_booster_docket_number,
            travel_booster_should_create_a_new_docket,
            price_comparable,
            currency: deal.currency,
            search_terms,
            client_custom_fields,
            hotel_search_token,

            ...(points.show && { show_points: points.show, user_chosen_points: points.user_chosen_points }),
        };
    }

    validateTravelersContacts() {
        Events.emit(SAVE_TRAVELER_CARD);

        const _self = this;
        return new Promise((resolve, reject) => _self.getTravelersContactPromise(resolve, reject));
    }

    forceTravelBoosterDocketNumberValidation() {
        if (this.state.travel_booster_integration_mandatory) {
            this.setState({
                force_travel_booster_docket_number_validation: true,
            });
        }
    }

    getTravelersContactPromise(resolve, reject) {
        const { reservationData, create_traveler_statuses } = this.state;

        const travelersBusy = create_traveler_statuses.includes(ReservationConstants.STATUS.BUSY);

        if (travelersBusy) {
            const _self = this;
            // user has tried to create a traveler
            // call again to this function every 200ms till there is a response
            setTimeout(() => {
                return _self.getTravelersContactPromise(resolve, reject);
            }, 200);
        } else {
            const travelersError = !_.isEmpty(reservationData.travelersErrors);

            if (travelersError) {
                // error in travelers
                Events.emit(SCROLL_TO_TRAVELER, reservationData.travelersErrors);
                return reject();
            } else {
                // no errors in travelers, continue to form validation
                return resolve();
            }
        }
    }

    addQuote() {
        this.validateTravelersContacts()
            .then(() => {
                if (!this.validateForm()) {
                    this.openValidationModal();
                } else {
                    const { reservationData, search_terms } = this.state;

                    ReservationActions.quoteReservation(reservationData, search_terms);

                    const trip_id = reservationData.management_trip_id;
                    const trip_name = reservationData.management_trip_name;
                    const traveler = reservationData.travelers[0];
                    const traveler_id = traveler && traveler.id;
                    const traveler_name = traveler && traveler.first_name + ' ' + traveler.last_name;
                    const traveler_email = traveler && traveler.email;

                    Analytics.actions.interactions.addedAsQuote(
                        trip_id,
                        trip_name,
                        traveler_id,
                        traveler_name,
                        traveler_email,
                    );
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    openModal() {
        const { profile, reservationData } = this.state;
        const isShowModal = !profile?.company?.partners_ui?.show_reservation_errors || !reservationData.bookingError;
        this.setState({
            modalIsOpen: isShowModal,
            isShowReservationError: !isShowModal,
        });
    }

    afterOpenModal() {
        //// references are now sync'd and can be accessed.
        //this.refs.subtitle.style.color = '#f00';
    }

    // FU-082. Like `closeModal`'s failure arm, minus `HotelActions.banDeal`: the deal did not fail — the
    // credit-line check could not run — so the customer goes back to the hotel page able to pick it again.
    closeCreditLineCheckUnavailableModal() {
        const { navigate } = this.props;
        const { hotel, search_terms, search_token } = this.state;

        this.setState({ creditLineModalIsOpen: false });
        ReservationActions.resetOutOfPolicyRequestStatus();
        RouterWrapper.goToHotelPage(navigate, hotel, search_token, search_terms);
        ReservationActions.clearReservation();
        PaymentActions.clearPaymentData();
    }

    closeModal() {
        const { navigate } = this.props;
        const { reservationData, out_of_policy_request_status, hotel, search_terms, deal, search_token } = this.state;

        /// if there was any error when trying to book, app will go back to hotel page and show other deals.
        /// if reservation confirmed, go to main page.
        if (reservationData.status === ReservationConstants.RESERVATION_OPERATION_STATE.QUOTED) {
            SearchActions.clearSearchTerms();
            RouterWrapper.goToTripPage(navigate, reservationData.management_trip_id);
        } else if (out_of_policy_request_status === ReservationConstants.STATUS.SUCCESS) {
            SearchActions.clearSearchTerms();
            RouterWrapper.goToSearchPage(navigate);
        } else if (
            out_of_policy_request_status === ReservationConstants.STATUS.FAILED ||
            (reservationData.status !== ReservationConstants.STATUS.BOOKED && !isPendingStatus(reservationData.status))
        ) {
            ReservationActions.resetOutOfPolicyRequestStatus();
            HotelActions.banDeal(hotel, deal);
            RouterWrapper.goToHotelPage(navigate, hotel, search_token, search_terms);
        } else if (reservationData.include_management_trip_id) {
            SearchActions.clearSearchTerms();
            RouterWrapper.goToTripPage(navigate, reservationData.management_trip_id);
        } else {
            this.handleCombtasSession();
            SearchActions.clearSearchTerms();
            RouterWrapper.goToSearchPage(navigate);
        }
        // TODO: clear stores
        ReservationActions.clearReservation();
        PaymentActions.clearPaymentData();
    }

    openQuotedReservationModal() {
        this.setState({ quotedReservationModalIsOpen: true });
    }

    closeQuotedReservationModal() {
        this.setState({ quotedReservationModalIsOpen: false });
    }

    openFailedReservationInitializationModal() {
        this.setState({ failedReservationInitializationModalIsOpen: true });
    }

    closeFailedReservationInitializationModal() {
        ReservationActions.clearReservation();

        const { navigate } = this.props;
        const { hotel, search_token, search_terms } = this.state;

        RouterWrapper.goToHotelPage(navigate, hotel, search_token, search_terms);
    }

    updateOutOfPolicyRequestReason(e) {
        ReservationActions.updateOutOfPolicyRequestReason(e.target.value);
    }

    onArbiManagementTripAssociation(event, isInputChecked) {
        event.persist();
        ReservationActions.updateIncludeManagementTripId(isInputChecked);
    }

    onTripIdChange(e) {
        // don't mistake with changing of management trip id ...
        this.setState({ trip_id: e.target.value });
    }

    onCombtasIdChange(e) {
        this.setState({
            combtas_id: e.target.value
                .replace(/\s/g, '') // removes spaces
                .toUpperCase(),
        });
    }

    onTravelBoosterDocketNumberChange(e) {
        this.setState({
            travel_booster_docket_number: e.target.value.replace(/\s/g, ''), // removes spaces
        });
    }

    onShouldCreateNewDocketChanged(event) {
        this.setState({
            travel_booster_should_create_a_new_docket: event.target.checked,
            ...(event.target.checked && { travel_booster_docket_number: '' }),
        });
    }

    onAgencyClientPriceChange(e) {
        ReservationActions.updateAgencyClientPrice(e.target.value);
    }

    handleUpdateChangeClientPrice(agentPricing) {
        ReservationActions.updateAgentPricing(agentPricing);
    }

    handleBnplMethodChange(method) {
        this.setState({ bnpl_method: method });
    }

    onPriceComparableChange(e) {
        this.setState({ price_comparable: e.target.value });
    }

    handleInvoiceChange(e) {
        const invoice_id = e.target.value;
        const invoice_option = this.state.profile.company.invoice_ids.find((option) => option.id === invoice_id);
        ReservationActions.updateInvoiceOption(invoice_option);
        this.setState({ isInvoiceOptionChanged: true });
    }

    handleSendVoucherSeparatelyCheckboxChange(event) {
        event.persist();
        this.setState({
            send_voucher_separately_from_confirmation_mail: event.target.checked,
            // TODO! Setting the separate voucher should disable the send to traveller and uncheck it.
            // for some odd reason it does not uncheck it now.
            send_email: false,
        });
    }

    handleSendEmailCheckboxChange(event) {
        event.persist();
        this.setState({ send_email: event.target.checked });
    }

    handleSpecialRequestCheckboxChange(event) {
        this.setState({ isSpecialRequestsChecked: event.target.checked });
    }

    clearSpecialRequests() {
        const { isSpecialRequestsChecked } = this.state;

        if (!isSpecialRequestsChecked && !this.shouldAlwaysShowSpecialRequests()) {
            ReservationActions.updateSpecialRequests('');
            ReservationActions.updateSpecialRequestsFromSuggestions({});
        }
    }

    handleSelectedCustomFieldChange(event) {
        this.setState({
            selected_company_custom_field: event.target.value,
            selected_company_custom_field_secondary: -1,
        });
    }

    handleSelectedSecondaryCustomFieldChange(event) {
        this.setState({ selected_company_custom_field_secondary: event.target.value });
    }

    handleCustomTextFieldChange(event, field) {
        event.persist();
        const custom_text_fields = this.state.company_custom_text_fields;
        custom_text_fields[field._id] = {
            label: field.label,
            value: event.target.value,
            show_on_invoice: field.show_on_invoice,
            show_on_voucher: field.show_on_voucher,
        };
        this.setState({ company_custom_text_fields: custom_text_fields });
    }

    handleCompanyCustomInputTextChange(event) {
        event.persist();
        this.setState({ company_custom_input_text: event.target.value });
    }

    handleCompanyCustomInputNumberChange(event) {
        event.persist();
        this.setState({ company_custom_input_number: event.target.value });
    }

    handleSelectedCustomFieldPathChange(event, path) {
        event.persist();
        this.setState({ selected_custom_fields_path: path + '_' + event.target.value });
    }

    didGetPaymentData() {
        const { paymentData } = this.state;

        return !!(paymentData && paymentData.creditCardUrl);
    }

    isReservationPostInitialStatus() {
        const { status } = this.state.reservationData;

        return (
            status === ReservationConstants.STATUS.BUSY ||
            status === ReservationConstants.STATUS.SUCCESS ||
            status === ReservationConstants.STATUS.FAILED
        );
    }

    shouldLockForm() {
        return this.isBusy() || this.didGetPaymentData() || this.isReservationPostInitialStatus();
        // TODO: think if we are missing more cases
    }

    shouldDisableAddAsQuoteAndProceedButtons() {
        // TODO: implement
        return false;
    }

    getClientTripIdRender() {
        const { t } = this.props;
        const { profile, trip_id } = this.state;

        const client_trip_id = _.get(profile, 'company.settings.client_trip_id', false);
        const client_trip_id_label = _.get(profile, 'company.settings.client_trip_id_label', t('TripId'));

        return client_trip_id ? (
            <div className="trip-id-container">
                <label htmlFor="client_trip_id">{client_trip_id_label}</label>
                <input
                    type="text"
                    className="form-control"
                    id="client_trip_id"
                    value={trip_id}
                    disabled={this.shouldLockForm()}
                    onChange={this.didGetPaymentData() ? null : this.onTripIdChange}
                    placeholder={'Your ' + client_trip_id_label + ' (Optional)'}
                    maxLength="36"
                />
            </div>
        ) : null;
    }

    isCombtasEnabled() {
        const { deal } = this.state;
        return this.state.combtas_integration_enabled && !_.get(deal, 'private_travel', false);
    }

    isTravelBoosterEnabled() {
        return this.state.travel_booster_integration_enabled;
    }

    isAgencyClientPriceEnabled() {
        const { profile, contract_client_company_id, deal } = this.state;

        return ClientPriceService.isEnabled(profile, contract_client_company_id, deal);
    }

    getCombtasRender() {
        const { reservationData, combtas_id, tas_id_ref } = this.state;

        return this.isCombtasEnabled() ? (
            <CombtasContainer
                reservationData={reservationData}
                combtasId={combtas_id}
                shouldLockForm={this.shouldLockForm() || tas_id_ref}
                onCombtasIdChange={this.onCombtasIdChange}
            />
        ) : null;
    }

    handleClickRedeemPoints() {
        this.setState({
            redeem_points_modal_open: true,
        });
    }

    handleCloseRedeemPoints() {
        this.setState({
            redeem_points_modal_open: false,
        });
    }

    handleApproveRedeemPoints(_points) {
        PointsActions.saveChosenUserPoints(_points);

        this.setState({
            redeem_points_modal_open: false,
        });
    }

    // getLoyaltyBoxRender() {
    //     const {
    //         private_travel,
    //         profile,
    //         points_status,
    //         points_balance,
    //         points_upcoming_value,
    //         points_upcoming_timestamp,
    //         reservationData,
    //         points
    //     } = this.state;
    //     return profile.loyalty.enabled
    //         ? <React.Fragment>
    //             <Button
    //                 aria-label="redeem points"
    //                 variant="contained"
    //                 color="primary"
    //                 className="use-points"
    //                 onClick={this.handleClickRedeemPoints}
    //                 disabled={this.props.initializing || this.props.shouldLock}
    //             >
    //                 Redeem Points
    //             </Button>

    //             <RedeemPoints
    //                 points={points}
    //                 reservation={reservationData}
    //                 initializing={reservationData.status === STATUS.INITIALIZING}
    //                 disabled={this.shouldLockForm()}
    //                 dialogOpen={this.state.redeem_points_modal_open}
    //                 dialogTitle="Redeem Points"
    //                 onClose={this.handleCloseRedeemPoints}
    //                 onApprove={this.handleApproveRedeemPoints}
    //                 profile={profile}
    //             />
    //             <LoyaltyBox
    //                 status={points_status}
    //                 balance={points_balance}
    //                 upcomingValue={points_upcoming_value}
    //                 upcomingTimestamp={points_upcoming_timestamp}
    //                 hasReservation={true}
    //                 reservation={reservationData}
    //                 points={points}
    //                 privateTravel={private_travel}
    //                 profile={profile}
    //             />
    //         </React.Fragment>
    //         : null;
    // }

    // TODO: implement if server and client both separate usage and earn
    // isLoyaltyUsageEnabled() {
    //     return this
    // }

    isLoyaltyEnabled() {
        const post_pay = _.get(this.state, 'reservationData.deal.post_pay', false);
        const loyalty = _.get(this.state, 'profile.loyalty', {});

        // TODO: comment out if server supports earn
        const out_of_policy_request =
            _.get(this.state, 'out_of_policy_state') === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK;
        const quote = this.shouldShowQuote();

        return (
            !post_pay &&
            loyalty.enabled &&
            // TODO: comment out if server supports earn
            !out_of_policy_request &&
            !quote
        );
    }

    getMaximumPointsEarnedRender() {
        const { t } = this.props;

        if (isElalCompany()) {
            return null;
        }

        if (this.isLoyaltyEnabled()) {
            const loyalty = _.get(this.state, 'profile.loyalty', {});
            const price_in_currency =
                _.get(this.state, 'deal.net_price_total') || _.get(this.state, 'reservationData.deal.totalPrice', 0);
            const expected_points_earned = Points.getExpectedPointsEarned({
                price_in_currency,
                points_used: 0,
                arbitrip_points_to_currency_exchange_rate: loyalty.arbitrip_points_to_currency_exchange_rate,
                private_travel: _.get(this.state, 'private_travel', false),
                arbitrip_loyalty_program: loyalty,
            });
            const expected_points_earned_currency_value = Currencies.getPriceWithDisplayCurrencyByPrecision(
                expected_points_earned * loyalty.arbitrip_points_to_currency_exchange_rate,
                1,
                _.get(this.state, 'profile.company_currency'),
                2,
            );
            const status = _.get(this.state, 'reservationData.status');
            const points_loading =
                status === ReservationConstants.STATUS.NEW ||
                status === ReservationConstants.STATUS.INITIALIZING ||
                status === ReservationConstants.STATUS.BUSY ||
                this.state.points_status === PointsConstants.STATUS.BUSY;
            return (
                <div className="maximum-points-earned" data-testid="maximum-points-earned">
                    <div className="maximum-points-earned-title">{t('PointsTitle')}</div>
                    <div className="maximum-points-earned-inner">
                        <div className="maximum-points-earned-icon">
                            <div className="maximum-points-earned-icon-inner">
                                <PointsIcon />
                            </div>
                        </div>
                        <div className="maximum-points-earned-text">{t('ForThisReservationYouCanEarnUpTo')}</div>

                        {/* TODO: content loader */}
                        {points_loading ? (
                            getContentLoader(170.81, 44, 8)
                        ) : (
                            <React.Fragment>
                                <div className="maximum-points-earned-points">
                                    <span className="maximum-points-earned-points-value">
                                        {expected_points_earned.toLocaleString()}
                                    </span>
                                    <span className="maximum-points-earned-points-suffix">
                                        {expected_points_earned === 1 ? t('Point') : t('Points')}
                                    </span>
                                    <span className="maximum-points-earned-points-suffix">
                                        ({expected_points_earned_currency_value})
                                    </span>
                                    <span className="maximum-points-earned-disclaimer">
                                        <Tooltip
                                            PopperProps={{
                                                modifiers: [{ name: 'offset', options: { offset: [0, -10] } }],
                                            }}
                                            placement="top"
                                            className="maximum-points-earned-disclaimer-tooltip"
                                            title={PointsStore.getPointsEarnedDisclaimerText(t)}
                                        >
                                            <IconButton sx={{ width: 20, height: 20 }}>
                                                <div className="maximum-points-earned-disclaimer-icon">
                                                    <InfoOutlined sx={{ fontSize: 20 }} />
                                                </div>
                                            </IconButton>
                                        </Tooltip>
                                    </span>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            );
        }

        return null;
    }

    getTravelBoosterRender() {
        const {
            travel_booster_integration_mandatory,
            travel_booster_docket_number,
            travel_booster_should_create_a_new_docket,
            force_travel_booster_docket_number_validation,
            profile,
        } = this.state;

        return this.isTravelBoosterEnabled() ? (
            <TravelBoosterContainer
                mandatory={!!travel_booster_integration_mandatory}
                travelBoosterDocketNumber={travel_booster_docket_number}
                shouldLockForm={this.shouldLockForm()}
                onTravelBoosterDocketNumberChange={this.onTravelBoosterDocketNumberChange}
                shouldCreateNewDocket={!!travel_booster_should_create_a_new_docket}
                onShouldCreateNewDocketChanged={this.onShouldCreateNewDocketChanged}
                shouldForceTravelBoosterDocketNumberValidation={!!force_travel_booster_docket_number_validation}
                profile={profile}
            />
        ) : null;
    }

    // getAgencyClientPriceRender() {
    //     return this.isAgencyClientPriceEnabled()
    //         // ? <AgencyClientPriceContainer
    //         //     agencyClientPrice={this.state.agency_client_price}
    //         //     shouldLockForm={this.shouldLockForm()}
    //         //     onAgencyClientPriceChange={this.onAgencyClientPriceChange}
    //         // />
    //         ? <AgentPricing
    //             initializing={(this.state.reservationData.status === STATUS.INITIALIZING)}
    //             reservation={this.state.reservationData}
    //             shouldLockForm={this.shouldLockForm()}
    //         />
    //         : null;
    // }

    getAddQuoteDisabledStatus() {
        return (
            !this.state.reservationData.include_management_trip_id ||
            this.isInitializingPayment() ||
            this.didGetPaymentData() ||
            this.isBusy()
        );
    }

    getPaymentOptionsDisabledStatus() {
        return this.isBusy() || this.state.showPaymentComponentOnQuoteFlow;
    }

    shouldShowQuote() {
        const { reservationData } = this.state;

        // show a quote if it came from management and is not a quote
        return reservationData.management_trip_id && !reservationData.quote_id;
    }

    getAddAsQuoteRender() {
        // add a quote if it came from management and is not a quote
        return this.shouldShowQuote() ? (
            <React.Fragment>
                <input
                    type="button"
                    className="btn btn-warning quote-button"
                    onClick={this.addQuote}
                    disabled={this.getAddQuoteDisabledStatus()}
                    value="Add as Quote"
                />

                <input
                    type="button"
                    className="btn btn-success proceed-button"
                    onClick={this.showPaymentComponentOnQuoteFlow}
                    disabled={this.getPaymentOptionsDisabledStatus()}
                    value="Payment Options"
                />
            </React.Fragment>
        ) : null;
    }

    showPaymentComponentOnQuoteFlow() {
        this.setState({ showPaymentComponentOnQuoteFlow: true });
    }

    getBackToHotelRender() {
        const { t } = this.props;
        const { hotel, search_token, searchTerms } = this.state;

        return (
            <div className="back-to-hotel">
                <Link to={RouterWrapper.buildHotelRoute(hotel, search_token, searchTerms)}>
                    <img src="/img/back_icon.svg" alt="back button" />
                    {t('BackToHotel')}
                </Link>
            </div>
        );
    }

    getTripIdCombtasBoosterContainerRender() {
        const clientTripIdRender = this.getClientTripIdRender();
        const combtasRender = this.getCombtasRender();
        const travelBoosterRender = this.getTravelBoosterRender();

        return clientTripIdRender || combtasRender || travelBoosterRender ? (
            <div className="inputs-container trip-id flex flex-wrap">
                {clientTripIdRender}
                {combtasRender}
                {travelBoosterRender}
            </div>
        ) : null;
    }

    getCreditLineErrorDialogRender() {
        const { t } = this.props;
        const { creditLineModalIsOpen } = this.state;

        // 'YYYY-MM' from the server, formatted HERE in the user's own locale rather than pre-formatted
        // server-side — otherwise the HE bundle inherits EN month names. Both strings name the month,
        // because under a per-month wall "insufficient credit" alone tells the customer nothing they
        // can act on: which month is full, that the others are fine, and what to ask finance for.
        const credit_line_bucket_month = _.get(this.state, 'reservationData.credit_line_bucket_month');
        const month = credit_line_bucket_month ? moment(credit_line_bucket_month, 'YYYY-MM').format('MMMM YYYY') : '';

        // NO MONTH MEANS A WHOLE-CAP BLOCK, and it needs its own copy rather than the same strings with
        // an empty parameter. The month-named strings rendered "Your credit line for  is fully used" and
        // then told the customer other months were unaffected — which under a block is false, since it
        // applies to every month. In a shadow-only phase the block is the ONLY refusal a customer can
        // reach, so this was the one reachable message.
        //
        // FU-082 — THE SERVER COULD NOT CHECK THE LINE AT ALL (CREDIT_LINE_CHECK_UNAVAILABLE). Retryable, and
        // nothing about the line is known, so neither the "fully used" nor the "on hold" content applies.
        // Closing it returns to the hotel page WITHOUT banning the deal, so the customer can try again.
        const check_unavailable = _.get(this.state, 'reservationData.credit_line_check_unavailable') === true;
        let title_key = month ? 'CreditLineErrorTitle' : 'CreditLineBlockedTitle';
        let content_key = month ? 'CreditLineErrorContent' : 'CreditLineBlockedContent';

        if (check_unavailable) {
            title_key = 'CreditLineBlockedTitle';
            content_key = 'CreditLineCheckUnavailableContent';
        }

        const on_close = check_unavailable ? this.closeCreditLineCheckUnavailableModal : this.closeModal;

        return (
            <MaterialDesignDialog
                open={creditLineModalIsOpen}
                onClose={on_close}
                closeTimeoutInMilliseconds={150}
                title={t(title_key, { month })}
                content={<div>{t(content_key, { month })}</div>}
                actions={[{ onClick: on_close, text: t('Reservation.GotIt') }]}
            />
        );
    }

    getGoToPaymentContainerRender() {
        return (
            <div className="go-to-payment-container">
                <div className="final-approval-make-reservation">
                    {this.getOutOfPolicyRequestRender()}
                    {this.getMakeReservationRender()}
                </div>
            </div>
        );
    }

    getPaymentComponentRender(canChangeChargeCurrency = false) {
        const { out_of_policy_state, showPaymentComponentOnQuoteFlow, points, reservationData, hotel } = this.state;
        const { newReservationDetails, existingReservationsDetails } = this.getDoubleBookingReservationDetails();

        return out_of_policy_state !== ReservationConstants.OUT_OF_POLICY_STATE.BLOCK &&
            (!this.shouldShowQuote() || showPaymentComponentOnQuoteFlow) ? (
            <PaymentComponent
                validForm={this.validateForm()}
                openValidationModal={this.openValidationModal}
                validateTravelersContacts={this.validateTravelersContacts}
                forceTravelBoosterDocketNumberValidation={this.forceTravelBoosterDocketNumberValidation}
                clearSpecialRequests={this.clearSpecialRequests}
                advanceReservationFields={this.getAdvanceReservationFields()}
                shouldLockForm={this.shouldLockForm()}
                busy={this.isBusy()}
                madeReservation={this.didMakeReservation()}
                profile={this.state.profile}
                hotel={hotel}
                canChangeChargeCurrency={canChangeChargeCurrency}
                loyaltyEnabled={this.isLoyaltyEnabled()}
                points={points}
                privateTravel={SearchStore.isPrivateTravel()}
                reservation={reservationData}
                isDoubleBookingModalIsOpen={this.state.isDoubleBookingModalIsOpen}
                checkingDoubleBooking={this.state.checkingDoubleBooking}
                checkDoubleBooking={this.checkDoubleBooking}
                doubleBookingStatus={this.state.doubleBookingStatus}
                isDoubleBooking={this.state.isDoubleBooking}
                newReservationDetails={newReservationDetails}
                existingReservationsDetails={existingReservationsDetails}
                handleDoubleBookingDialogResponse={this.handleDoubleBookingDialogResponse}
                onCouponValidated={this.onCouponValidated}
                couponValidation={this.state.coupon_validation}
                onPaymentMethodChange={this.handleBnplMethodChange}
            />
        ) : null;
    }

    isInitializingPayment() {
        return this.state.paymentData.status === PaymentConstants.STATUS.INITIALIZING;
    }

    isFetchingPoints() {
        if (this.state.profile.loyalty.enabled) {
            if (this.state.points_status === ProfileConstants.STATUS.BUSY) {
                return false;
            }
        }

        return false;
    }

    isBusy() {
        return (
            this.isInitializingPayment() ||
            this.isMakingOutOfPolicyRequest() ||
            this.isQuoting() ||
            this.isMakingReservation() ||
            this.state.isDoubleBookingModalIsOpen ||
            this.state.checkingDoubleBooking ||
            this.isFetchingPoints()
        );
    }

    didMakeReservation() {
        const { status } = this.state.reservationData;

        return (
            status === ReservationConstants.STATUS.SUCCESS ||
            status === ReservationConstants.STATUS.FAILED ||
            status === ReservationConstants.STATUS.BOOKED
        );
    }

    getSpinnerRender(condition) {
        return condition ? <i className="fa fa-spin fa-spinner fa-2x" /> : null;
    }

    handleCombtasSession() {
        const { combtas_id, tas_id_ref } = this.state;

        if (this.isCombtasEnabled() && tas_id_ref) {
            removeTasIdFromSessionStorage();

            if (combtas_id === tas_id_ref) {
                try {
                    // Notify other tabs to close the current tasId session if a reservation was made with the same tasId
                    channel.postMessage(this.state.combtas_id);
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }

    shouldAlwaysShowSpecialRequests() {
        return _.get(this.state.profile, 'company.partners_ui.expanded_special_requests', false);
    }

    // OB-53 — THE ONE PLACE that decides whether the request button is disabled, and WHY.
    //
    // Returns `null` when the request is sendable, otherwise the sentence to show. The disjunction and
    // the copy are computed from the same terms in the same order, so the button can never be dead
    // without a reason on screen. A new term added to the disjunction must get a branch here too.
    //
    // The credit-line copy is gated STRICTLY on `credit_line_blocked` — the live availability read
    // saying "no". A form rule must never be reported as the credit line being short: that is a claim
    // about the customer's account that nothing has established.
    getOutOfPolicyRequestDisabledReason() {
        const { t } = this.props;
        const { out_of_policy_request_status, reservationData, checkingDoubleBooking } = this.state;

        if (out_of_policy_request_status === ReservationConstants.STATUS.BUSY) {
            return t('RequestThisRoomDisabledSending');
        }

        if (checkingDoubleBooking) {
            return t('RequestThisRoomDisabledCheckingDoubleBooking');
        }

        if (!reservationData.id || reservationData.status === ReservationConstants.STATUS.INITIALIZING) {
            return t('RequestThisRoomDisabledReservationNotReady');
        }

        // OB-35: a request the company's credit line cannot absorb would be approved and then refused
        // at booking time. Withhold the button with a reason instead — only when the read actually said
        // so; pending and failed reads leave it enabled (isAccountPaymentOfferedForRequest fails open).
        if (!this.isAccountPaymentOfferedForRequest()) {
            return this.getOutOfPolicyRequestUnavailableReason();
        }

        const form_invalidation = this.getFormInvalidation();

        if (form_invalidation) {
            return t(form_invalidation.key, form_invalidation.params);
        }

        if (!this.validateTravelers()) {
            return t('RequestThisRoomDisabledMissingTravelers');
        }

        return null;
    }

    getOutOfPolicyRequestButton() {
        const { t } = this.props;

        const disabled_reason = this.getOutOfPolicyRequestDisabledReason();
        const out_of_policy_request_disabled = Boolean(disabled_reason);

        // NOT a tooltip. Three rounds of tooltip fixes (a span anchor, an always-mounted anchor with an
        // empty title) each looked right in a harness and each still left the customer hovering a dead
        // button with no explanation. A sentence that is simply RENDERED cannot fail to open: no hover,
        // no pointer-events, no portal, no anchor-under-a-resting-cursor. Reliability over elegance.
        return (
            <React.Fragment>
                <Button
                    variant="contained"
                    color="primary"
                    className="btn request-this-room"
                    onClick={out_of_policy_request_disabled ? _.noop : this.requestThisRoom}
                    disabled={out_of_policy_request_disabled}
                >
                    {t('RequestThisRoom')}
                </Button>
                {out_of_policy_request_disabled && (
                    <div className="request-this-room-disabled-reason" role="status" aria-live="polite">
                        {disabled_reason}
                    </div>
                )}
            </React.Fragment>
        );
    }

    isMakingOutOfPolicyRequest() {
        return (
            this.state.out_of_policy_request_status === ReservationConstants.STATUS.BUSY ||
            this.state.checkingDoubleBooking
        );
    }

    isQuoting() {
        return this.state.reservationData.status === ReservationConstants.RESERVATION_OPERATION_STATE.QUOTING;
    }

    isMakingReservation() {
        return this.state.reservationData.status === ReservationConstants.STATUS.BOOKING;
    }

    getMakeReservationRender() {
        const { out_of_policy_state } = this.state;

        // TODO: remove MaterialDesignDialog after tests

        if (out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK) {
            return (
                <div id="make-reservation" className="make-reservation">
                    {this.getOutOfPolicyRequestButton()}
                    {this.getSpinnerRender(this.isMakingOutOfPolicyRequest())}
                    {this.reservationStateDialogs()}
                </div>
            );
        } else {
            return (
                <div id="make-reservation" className="make-reservation">
                    {this.getAddAsQuoteRender()}
                    {this.getSpinnerRender(this.isQuoting())}
                    {this.reservationStateDialogs()}
                </div>
            );
        }
    }

    reservationStateDialogs() {
        const {
            out_of_policy_state,
            out_of_policy_request_status,
            modalIsOpen,
            quotedReservationModalIsOpen,
            failedReservationInitializationModalIsOpen,
            reservationData,
            hotel,
            profile,
        } = this.state;

        const isPending = isPendingStatus(reservationData.status);
        const isSuccess = reservationData.status === ReservationConstants.STATUS.BOOKED;
        const isOutOfPolicy =
            out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK &&
            out_of_policy_request_status === ReservationConstants.STATUS.SUCCESS;
        const isError = !isPending && !isSuccess && !isOutOfPolicy;
        return (
            <div>
                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.SUCCESS}
                    shortId={reservationData?.short_id}
                    reservationId={reservationData?.id}
                    modalIsOpen={modalIsOpen && isSuccess}
                    primeButtonAction={this.closeModal}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.PENDING}
                    shortId={reservationData?.short_id}
                    reservationId={reservationData?.id}
                    modalIsOpen={modalIsOpen && isPending}
                    isNonRefundable={_.get(reservationData, 'deal.dca.nonRefundable') === true}
                    primeButtonAction={this.closeModal}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.FAILED}
                    reservationId={reservationData?.id}
                    modalIsOpen={modalIsOpen && isError}
                    primeButtonAction={this.closeModal}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.ROOM_NOT_AVAILABLE}
                    reservationId={reservationData?.id}
                    modalIsOpen={failedReservationInitializationModalIsOpen}
                    primeButtonAction={this.closeModal}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.OUT_OF_POLICY}
                    reservationId={reservationData?.id}
                    modalIsOpen={modalIsOpen && isOutOfPolicy}
                    primeButtonAction={this.closeModal}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.QUOTE}
                    reservationId={reservationData?.id}
                    modalIsOpen={quotedReservationModalIsOpen}
                    tripName={reservationData?.management_trip_name}
                    primeButtonAction={() => {
                        this.closeQuotedReservationModal();
                        this.closeModal();
                    }}
                />

                <ReservationDialog
                    profile={profile}
                    hotel={hotel}
                    variant={RESERVATION_DIALOG_VARIANT.LOYALTY_CARD_ERROR}
                    reservationId={reservationData?.id}
                    modalIsOpen={!!this.state.paymentData?.loyalty_card_error}
                    primeButtonAction={() => {
                        PaymentActions.clearPaymentData();
                    }}
                />
            </div>
        );
    }

    isPayAtHotel() {
        // TODO: obtain current payment method (currently stored in PaymentComponent state)
        // return false;

        // logically pay-at-hotel payment method is the only option when deal is post_pay
        return this.state.post_pay;
    }

    getManagementTripIdRender() {
        const { reservationData } = this.state;

        return reservationData.management_trip_id ? (
            <div className="management-trip-container">
                <Checkbox
                    disabled={this.shouldLockForm()}
                    label={`Attach booking to: '${reservationData.management_trip_name}'`}
                    checked={reservationData.include_management_trip_id}
                    onCheck={this.onArbiManagementTripAssociation}
                />
            </div>
        ) : null;
    }

    getIssueInvoiceRender() {
        const { t } = this.props;
        const { private_travel, profile, isInvoiceOptionChanged } = this.state;

        const { invoice_ids } = profile.company;
        const invoice_option = this.getSelectedInvoiceId();

        // TODO: should we support a single invoice id as well? (originally it wasn't supported)
        if (companyOffersInvoiceIdentityChoice(profile.company, private_travel)) {
            const disabled =
                this.shouldLockForm() ||
                (profile.employee && !profile.isApprovalFlowPowerUser() && invoice_option && !isInvoiceOptionChanged);

            return (
                <div className="invoice-options-container">
                    <h4 className="title">{t('IssueInvoiceOfficeSite')}</h4>
                    <div className="invoice-options-content">
                        <FormControl fullWidth variant="outlined" disabled={this.shouldLockForm()}>
                            <label>{t('SelectCompanyLabel')}</label>
                            <Select
                                id="invoice-options"
                                className={invoice_option ? 'selected' : ''}
                                value={invoice_option || ''}
                                onChange={this.handleInvoiceChange}
                                displayEmpty
                                disabled={disabled}
                            >
                                <MenuItem value="" disabled>
                                    {t('SelectCompanyPlaceholder')}
                                </MenuItem>
                                {invoice_ids.map((invoice) => (
                                    <MenuItem key={invoice.id} value={invoice.id}>
                                        {invoice.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    getOutOfPolicyRequestRender() {
        const { t } = this.props;
        const { reservationData, out_of_policy_state, textBoxError } = this.state;
        const initializing = reservationData.status === ReservationConstants.STATUS.INITIALIZING;

        if (out_of_policy_state && out_of_policy_state !== ReservationConstants.OUT_OF_POLICY_STATE.BYPASS) {
            let out_of_policy_request_title, out_of_policy_request_explanation;
            if (out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.WARNING) {
                out_of_policy_request_title = t('BookOutOfPolicyRoom');
                out_of_policy_request_explanation = (
                    <div className="out-of-policy-request-explanation">
                        <span>{t('OutOfPolicyExplanation')}</span>
                        <br />
                        <span>{t('ProvideReasonForBooking')}</span>
                    </div>
                );
            } else if (out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK) {
                out_of_policy_request_title = t('RequestThisRoom');
                out_of_policy_request_explanation = (
                    <div className="out-of-policy-request-explanation">
                        <span>{t('RequestRoomExplanation')}</span>
                        <br />
                        {this.getTravelPolicyText()}
                        <br />
                        <span>{t('PleaseProvideReason')}</span>
                    </div>
                );
            }

            return (
                <div className="out-of-policy-request-container">
                    <h4 className="title">{out_of_policy_request_title}</h4>
                    <div className="out-of-policy-request-content">
                        <div className="out-of-policy-request" id="out-of-policy-request">
                            {out_of_policy_request_explanation}
                            <div className="out-of-policy-request-reason">
                                <textarea
                                    className={`text-box ${textBoxError ? 'error' : ''}`}
                                    onChange={this.updateOutOfPolicyRequestReason}
                                    disabled={initializing}
                                    value={reservationData.out_of_policy_booking_reason}
                                    placeholder={t('OutOfPolicyReasonPlaceholder')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }

    getTravelPolicyText() {
        const { t } = this.props;
        const { deal, travel_policy: travelPolicy } = this.state;
        const doesTravelPolicyExist = travelPolicy && (travelPolicy.default || travelPolicy.place);
        const isInPolicy = deal.in_policy;
        if (!doesTravelPolicyExist || isInPolicy) return null;
        const travelPolicyCurrency = doesTravelPolicyExist ? Currencies.getSymbol(travelPolicy.currency) : '';
        const travelPolicyLocation =
            travelPolicy && travelPolicy.default
                ? t('ThisDestination')
                : travelPolicy && travelPolicy.place
                  ? travelPolicy.place.city || travelPolicy.place.state || travelPolicy.place.country
                  : '';
        return (
            <span className="out-of-policy-message">
                {deal.out_of_policy_message ||
                    t('MaximumPriceAllowedForDestination', {
                        location: travelPolicyLocation,
                        currency: travelPolicyCurrency,
                        price: travelPolicy.price,
                    })}
            </span>
        );
    }

    getReservationErrorRender() {
        const { hotel, reservationData, search_terms, search_token } = this.state;
        const { navigate, t } = this.props;

        let errorText = reservationData.bookingError;

        if (errorText === 'error') {
            errorText = t('AnIssueOccurredWithPaymentCard'); // wording slightly changed here with translation
        }
        if (!errorText) {
            return null;
        }

        const searchText = t('PleaseTryChoosing');
        const parts = errorText.split(searchText);
        const beforeText = parts[0];
        const afterText = parts[1] ? searchText + parts[1] : '';

        const handleClick = () => {
            RouterWrapper.goToHotelPage(navigate, hotel, search_token, search_terms);
        };

        return (
            <div className="booking-error-message">
                <AttentionIcon className="icon" />
                <span>{beforeText}</span>
                {afterText && (
                    <span className="error-action" onClick={handleClick}>
                        {afterText}
                    </span>
                )}
            </div>
        );
    }

    getPriceChangedModal() {
        const { reservationData, hotel, profile, deal, search_token } = this.state;
        const priceChangedData = reservationData.deal?.priceChangedData;
        if (!priceChangedData) {
            return null;
        }

        const isShowPriceChangedModal = !priceChangedData.confirmedChange;

        const rateCheckActionProps = {
            popup_type: 'changes_detected',
            recheck_type: RECHECK_TYPE.UPFRONT,
            price_changed: true,
            old_price: priceChangedData.oldPrice,
            new_price: priceChangedData.newPrice,
            deadline_changed: false,
            deal,
            search_id: search_token,
            popup_exposure_count_in_search: this._rateCheckPopupCount ?? 1,
        };

        const handleBack = () => {
            Analytics.actions.responses.roomRateCheckPopupAction({ action: 'back_to_hotel', ...rateCheckActionProps });
            ReservationActions.clearReservation();
            HotelActions.banDeal(hotel, reservationData.deal);
            ReservationActions.resetOutOfPolicyRequestStatus();
            const search_terms = SearchStore.getSearchTerms();
            const token = SearchStore.getToken();
            RouterWrapper.goToHotelPage(this.props.navigate, hotel, token, search_terms);
        };

        return (
            <TermsChangedDialog
                profile={profile}
                deal={reservationData.deal}
                roomName={RecheckAlternative.getRoomName(reservationData.deal)}
                nights={reservationData.deal?.nights}
                rooms={reservationData.deal?.rooms}
                points={isElalCompany() ? PointsStore.getPoints() : null}
                pointsBudget={isElalCompany() ? PointsStore.getPoints()?.user_chosen_points || 0 : 0}
                oldPrice={priceChangedData.oldPrice}
                newPrice={priceChangedData.newPrice}
                priceChanged={true}
                deadlineChanged={false}
                modalIsOpen={isShowPriceChangedModal}
                onBack={handleBack}
                onConfirm={() => {
                    Analytics.actions.responses.roomRateCheckPopupAction({ action: 'confirm', ...rateCheckActionProps });
                    ReservationActions.confirmPriceChanged();
                }}
            />
        );
    }

    getDoubleBookingReservationDetails() {
        const { hotel, reservationData, doubleBookingExistingReservations } = this.state;
        const { i18n } = this.props;

        const formatDate = (date) => DateUtils.parseFormatDate(date)?.locale(i18n.language)?.format('DD MMM YYYY') || '';

        const newReservationDetails = {
            hotelName: _.get(hotel, 'name'),
            checkInDate: formatDate(_.get(reservationData, 'deal.details.check_in')),
            checkOutDate: formatDate(_.get(reservationData, 'deal.details.check_out')),
        };

        const existingReservationsDetails = (doubleBookingExistingReservations || []).map((existingReservation) => ({
            hotelName: _.get(existingReservation, 'hotelName'),
            checkInDate: formatDate(_.get(existingReservation, 'checkIn')),
            checkOutDate: formatDate(_.get(existingReservation, 'checkOut')),
            shortId: _.get(existingReservation, 'shortId'),
        }));

        return { newReservationDetails, existingReservationsDetails };
    }

    renderDoubleBookingDialog() {
        const { out_of_policy_state, isDoubleBookingModalIsOpen } = this.state;

        if (out_of_policy_state !== ReservationConstants.OUT_OF_POLICY_STATE.BLOCK) {
            return null;
        }

        const { newReservationDetails, existingReservationsDetails } = this.getDoubleBookingReservationDetails();

        return (
            <DoubleBookingDialog
                isOpen={isDoubleBookingModalIsOpen}
                responseAction={this.handleDoubleBookingDialogResponse}
                newReservationDetails={newReservationDetails}
                existingReservationsDetails={existingReservationsDetails}
            />
        );
    }

    checkDoubleBooking() {
        const { reservationData } = this.getAdvanceReservationFields();
        const { profile, out_of_policy_state } = this.state;

        const reservation_id = _.get(reservationData, 'id');
        const check_in = _.get(reservationData, 'deal.details.check_in');
        const check_out = _.get(reservationData, 'deal.details.check_out');
        const travellers = _.get(reservationData, 'travelers', []);
        const company_id = _.get(profile, 'company.id');
        const user_id = _.get(profile, 'id');
        const is_reservations_and_requests = out_of_policy_state === ReservationConstants.OUT_OF_POLICY_STATE.BLOCK;

        ReservationActions.checkDoubleBooking({
            reservation_id,
            check_in,
            check_out,
            travellers,
            company_id,
            user_id,
            is_reservations_and_requests,
        });

        this.setState({ checkingDoubleBooking: true });
    }

    handleDoubleBookingDialogResponse(response) {
        this.setState({ isDoubleBookingModalIsOpen: false });

        if (this.state.out_of_policy_state !== ReservationConstants.OUT_OF_POLICY_STATE.BLOCK || !response) {
            return;
        }
        this.requestOutOfPolicyRoom();
    }

    render() {
        const {
            profile,
            private_travel,
            reservationData,
            create_traveler_statuses,
            contract_client_name,
            send_email,
            send_voucher_separately_from_confirmation_mail,
            selected_company_custom_field,
            selected_company_custom_field_secondary,
            hotel,
            deal,
            validationModalIsOpen,
            contract_client_company_id,
            points,
            isShowReservationError,
            showConfirmationPage,
            isSpecialRequestsChecked,
            isShowExpiredError,
            company_custom_text_fields,
        } = this.state;

        if (!deal || !deal.chooseprod || !reservationData || !hotel || Object.keys(deal).length === 0 || Object.keys(hotel).length === 0) {
            // render() runs before componentDidMount redirects; bail early to avoid crashing on empty stores
            return null;
        }
        const hotel_name = _.get(hotel, 'name');
        const title = TitleManager.buildTitleStartsWith(`Hotel${hotel_name ? ' ' + hotel_name : ''}`, true, true);

        const leisure_allowed_payment_currencies = _.get(profile, 'leisure_allowed_payment_currencies', []);
        const canChangeChargeCurrency =
            leisure_allowed_payment_currencies.length > 1 && // If less, no change possible
            private_travel; // currently supported only for private travel on credit cards
        const initializing = reservationData.status === STATUS.INITIALIZING;

        if (showConfirmationPage) {
            return (
                <ConfirmationPage
                    reservation={reservationData}
                    hotel={hotel}
                    profile={profile}
                    couponValidation={this.state.coupon_validation}
                    points={points}
                />
            );
        }

        return (
            <DocumentTitle title={title}>
                <div className="reservation-page flex flex-column">
                    {
                        <React.Fragment>
                            {this.getBackToHotelRender()}
                            <div className="reservation-container top-container">
                                <div className="reservation-main">
                                    <HotelDetailsContainer
                                        profile={profile}
                                        hotel={hotel}
                                        canChangeChargeCurrency={canChangeChargeCurrency}
                                        reservation={reservationData}
                                    />

                                    {reservationData.bnpl_eligible && <BnplTopBanner />}

                                    <CancellationTermsContainer
                                        profile={profile}
                                        hotel={hotel}
                                        reservation={reservationData}
                                    />

                                    {/* {this.getLoyaltyBoxRender()} */}

                                    {this.getMaximumPointsEarnedRender()}

                                    <TravelersDetailsContainer
                                        profile={profile}
                                        reservationData={reservationData}
                                        createTravelerStatuses={create_traveler_statuses}
                                        shouldLockForm={this.shouldLockForm()}
                                        contractClientName={contract_client_name}
                                        sendVoucherSeparatelyFromConfirmationMail={
                                            send_voucher_separately_from_confirmation_mail
                                        }
                                        handleSendVoucherSeparatelyCheckboxChange={
                                            this.handleSendVoucherSeparatelyCheckboxChange
                                        }
                                        sendEmail={send_email}
                                        handleSendEmailCheckboxChange={this.handleSendEmailCheckboxChange}
                                        autoFill={Config.dev_mode && Config.auto_fill}
                                    />

                                    {isElalCompany() && (
                                        <BillingSection
                                            billingEmail={_.get(reservationData, 'billing_email', '') || ''}
                                            onBillingEmailChange={ReservationActions.updateBillingEmail}
                                            onBillingFieldBlur={() => this.setState({ billing_validation_enabled: true })}
                                            disabled={this.shouldLockForm()}
                                            validationEnabled={this.state.billing_validation_enabled}
                                        />
                                    )}

                                    <CustomFieldsContainer
                                        reservationData={reservationData}
                                        shouldLockForm={this.shouldLockForm()}
                                        handleCustomTextFieldChange={this.handleCustomTextFieldChange}
                                        handleSelectedCustomFieldChange={this.handleSelectedCustomFieldChange}
                                        handleSelectedSecondaryCustomFieldChange={
                                            this.handleSelectedSecondaryCustomFieldChange
                                        }
                                        selectedCompanyCustomField={selected_company_custom_field}
                                        selectedCompanyCustomFieldSecondary={selected_company_custom_field_secondary}
                                        companyCustomTextFields={company_custom_text_fields}
                                    />

                                    <SpecialRequests
                                        alwaysShowSpecialRequests={this.shouldAlwaysShowSpecialRequests()}
                                        isChecked={isSpecialRequestsChecked}
                                        handleChecked={this.handleSpecialRequestCheckboxChange}
                                        reservationData={reservationData}
                                        shouldLockForm={this.shouldLockForm()}
                                    />

                                    <TermsOfSupplier
                                        deal={deal}
                                        reservation={reservationData}
                                        initializing={initializing}
                                    />

                                    {this.getTripIdCombtasBoosterContainerRender()}

                                    {this.getManagementTripIdRender()}

                                    {this.getIssueInvoiceRender()}

                                    {this.getGoToPaymentContainerRender()}

                                    {this.getCreditLineErrorDialogRender()}

                                    {!isShowReservationError && this.getPaymentComponentRender(canChangeChargeCurrency)}

                                    {isShowReservationError && this.getReservationErrorRender()}

                                    {isShowExpiredError && (
                                        <ExpiredResultsComponent
                                            type={EXPIRED_TYPES.BACK_TO_RESULTS}
                                            expiredEntityText="Results"
                                            expired={isShowExpiredError}
                                        />
                                    )}

                                    <ValidationDialog
                                        open={validationModalIsOpen}
                                        onClose={this.closeValidationModal}
                                    />

                                    {this.getPriceChangedModal()}

                                    {this.renderDoubleBookingDialog()}
                                </div>
                                <div className="reservation-side" data-testid="reservation-price-box">
                                    {PriceBreakdown.isBreakdownPrice({ profile, reservation: reservationData }) ? (
                                        <ExpediaDealDetailsContainer
                                            profile={profile}
                                            initializing={initializing}
                                            initialized={
                                                reservationData.status === ReservationConstants.STATUS.INITIALIZED
                                            }
                                            reservation={reservationData}
                                        />
                                    ) : (
                                        <PriceSummary
                                            profile={profile}
                                            shouldLock={this.shouldLockForm()}
                                            hotel={hotel}
                                            initializing={initializing}
                                            initialized={
                                                reservationData.status === ReservationConstants.STATUS.INITIALIZED
                                            }
                                            canChangeChargeCurrency={canChangeChargeCurrency}
                                            agencyClientPriceEnabled={this.isAgencyClientPriceEnabled()}
                                            reservation={reservationData}
                                            contractClientCompanyId={contract_client_company_id}
                                            points={points}
                                            couponValidation={this.state.coupon_validation}
                                            arbitripPointsApplied={ResultsStore.areArbitripPointsApplied()}
                                            onUpdateChangeClientPrice={this.handleUpdateChangeClientPrice}
                                            selectedPaymentMethod={this.state.bnpl_method}
                                        />
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </DocumentTitle>
        );
    }

    _onChange() {
        const prevState = this.state;
        let nextState = getReservationPageState();

        nextState.selected_company_custom_field = prevState.selected_company_custom_field;
        nextState.selected_company_custom_field_secondary = prevState.selected_company_custom_field_secondary;
        const reservationShortId = nextState.reservationData?.short_id || nextState.reservationData?.id;
        nextState.company_custom_text_fields = { ...prevState.company_custom_text_fields };
        if (reservationShortId) {
            (nextState.reservationData.company_custom_fields || []).forEach(f => {
                if (!f || !f._id) return;
                if (isReservationIdField(f) && !nextState.company_custom_text_fields[f._id]) {
                    nextState.company_custom_text_fields[f._id] = { label: f.label, value: reservationShortId, show_on_invoice: f.show_on_invoice, show_on_voucher: f.show_on_voucher };
                }
            });
        }
        nextState.isInvoiceOptionChanged = prevState.isInvoiceOptionChanged;
        nextState.bnpl_method = prevState.bnpl_method;

        // patch around combtas being overridden by search store
        if (prevState.combtas_id) {
            nextState.combtas_id = prevState.combtas_id;
        }

        // patch around travel booster being overridden by search store
        if (prevState.travel_booster_docket_number) {
            nextState.travel_booster_docket_number = prevState.travel_booster_docket_number;
        }

        this.setState(nextState);

        if (prevState.reservationData.status) {
            if (prevState.reservationData.status === ReservationConstants.STATUS.FAILED_RESERVATION_INITIALIZATION) {
                console.log('RSRV STATUS = FAILED INIT');
                this.openFailedReservationInitializationModal();
            } else if (prevState.reservationData.status === ReservationConstants.RESERVATION_OPERATION_STATE.QUOTED) {
                console.log('RSRV quoted');
                this.openQuotedReservationModal();
            } else if (
                prevState.reservationData.status === ReservationConstants.STATUS.BOOKED ||
                isPendingStatus(prevState.reservationData.status) ||
                prevState.reservationData.status === ReservationConstants.STATUS.FAILED ||
                prevState.out_of_policy_request_status === ReservationConstants.STATUS.SUCCESS ||
                prevState.out_of_policy_request_status === ReservationConstants.STATUS.FAILED
            ) {
                const credit_line_status = _.get(prevState, 'reservationData.credit_line_status');
                if (credit_line_status === ReservationConstants.STATUS.FAILED) {
                    this.setState({ creditLineModalIsOpen: true });
                } else {
                    this.handleCombtasSession();
                    const shouldShowConfirmationPage = _.get(
                        prevState,
                        'profile.company.partners_ui.show_check_out_page',
                        false,
                    );
                    if (
                        shouldShowConfirmationPage &&
                        prevState.reservationData.status !== ReservationConstants.STATUS.FAILED
                    ) {
                        this.setState({ showConfirmationPage: true });
                    } else {
                        this.openModal();
                    }
                }
            }
        }
    }
}

function getClientCustomFields(
    company_custom_fields,
    selected_company_custom_field_index,
    selected_company_custom_field_secondary_index,
    company_custom_text_fields,
) {
    let client_custom_fields = null;
    const company_fields = company_custom_fields;
    if (company_fields) {
        client_custom_fields = Object.assign({}, company_custom_text_fields);

        const first_combobox_custom_field = company_fields.find((custom_field) =>
            isNonEmptyArray(_.get(custom_field, 'list')),
        );

        if (
            first_combobox_custom_field &&
            first_combobox_custom_field.list &&
            first_combobox_custom_field.list[selected_company_custom_field_index] &&
            first_combobox_custom_field.list[selected_company_custom_field_index].label
        ) {
            const selected_field = first_combobox_custom_field.list[selected_company_custom_field_index];
            // company_custom_fields_results.first = selected_field.label;
            const key_first = selected_field._id || moment() + 'a';
            client_custom_fields[key_first] = {
                label: first_combobox_custom_field.label,
                value: selected_field.label,
                show_on_invoice: first_combobox_custom_field.show_on_invoice,
                show_on_voucher: first_combobox_custom_field.show_on_voucher,
            };

            if (selected_field.meta) {
                client_custom_fields[key_first].meta = selected_field.meta;
            }

            if (
                selected_field.list &&
                selected_field.list[selected_company_custom_field_secondary_index] &&
                selected_field.list[selected_company_custom_field_secondary_index].label
            ) {
                // company_custom_fields_results.second = selected_field.list[this.state.selected_company_custom_field_secondary].label;
                const selected_second_field = selected_field.list[selected_company_custom_field_secondary_index];
                const key_second = selected_second_field._id || moment() + 'b';
                client_custom_fields[key_second] = {
                    label: selected_field.label,
                    value: selected_second_field.label,
                    show_in_invoice: first_combobox_custom_field.show_on_invoice,
                    show_on_invoice: first_combobox_custom_field.show_on_invoice,
                    show_on_voucher: first_combobox_custom_field.show_on_voucher,
                };

                if (selected_second_field.meta) {
                    client_custom_fields[key_second].meta = selected_second_field.meta;
                }
            }
        }
    }

    return client_custom_fields;
}

export default withTranslation()(withRouter(ReservationPaymentPage));
